import React, { useState } from 'react';
import { formatCurrency } from '../utils';
import { useLanguage } from '../../../i18n';

const InvestTooltip = ({ show, children }) => {
  if (!show) return null;
  return (
    <div style={{
      position: 'absolute', bottom: '100%', left: '0', marginBottom: '8px',
      padding: '12px 14px', background: '#333', color: 'white', borderRadius: '8px',
      fontSize: '0.8rem', fontWeight: 'normal', whiteSpace: 'normal', zIndex: 1000,
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)', width: '320px', textAlign: 'left', lineHeight: '1.5'
    }}>
      {children}
      <div style={{ position: 'absolute', bottom: '-6px', left: '20px', width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderTop: '6px solid #333' }}></div>
    </div>
  );
};

const SystemCard = ({ title, borderColor, bgColor, textColor, investValue, yearlyValue, currency, locale, tooltipContent }) => {
  const { t } = useLanguage();
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div style={{ padding: '1.25rem', background: bgColor, borderRadius: '12px', border: `2px solid ${borderColor}` }}>
      <h3 style={{ fontSize: '1rem', fontWeight: '600', color: textColor, marginBottom: '1rem' }}>{title}</h3>
      <div style={{ marginBottom: '0.75rem' }}>
        <div style={{ fontSize: '0.875rem', color: '#666', display: 'flex', alignItems: 'center', gap: '0.5rem', position: 'relative' }}>
          <span>{t('investPlusRenewal')}</span>
          <div 
            style={{ 
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: '14px', height: '14px', borderRadius: '50%', background: borderColor,
              color: 'white', fontSize: '0.6rem', fontWeight: 'bold', cursor: 'pointer', flexShrink: 0
            }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={() => setShowTooltip(!showTooltip)}
          >
            i
            <InvestTooltip show={showTooltip}>{tooltipContent}</InvestTooltip>
          </div>
        </div>
        <div style={{ fontSize: '1.25rem', fontWeight: '600', color: textColor }}>
          {formatCurrency(investValue, currency, locale)}
        </div>
      </div>
      <div>
        <div style={{ fontSize: '0.875rem', color: '#666' }}>{t('operatingCostsPerYear')}</div>
        <div style={{ fontSize: '1.25rem', fontWeight: '600', color: textColor }}>
          {formatCurrency(yearlyValue, currency, locale)}
        </div>
      </div>
    </div>
  );
};

const SystemCards = ({ calculationResult, convertToDisplayCurrency }) => {
  const { t } = useLanguage();
  const currency = calculationResult.currency;
  const locale = calculationResult.display_locale;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '2rem' }}>
      <SystemCard
        title={t('systemSeparatusShort')}
        borderColor="#4CAF50"
        bgColor="#E8F5E9"
        textColor="#1B5E20"
        investValue={convertToDisplayCurrency(calculationResult.invest_anteil_separatus || 0)}
        yearlyValue={convertToDisplayCurrency(calculationResult.jahreskosten_separatus || 0)}
        currency={currency}
        locale={locale}
        tooltipContent={
          <>
            <div style={{ marginBottom: '8px' }}>{t('separatusInvestTooltip1')}</div>
            <div style={{ marginBottom: '6px' }}>{t('separatusInvestTooltip2')}</div>
            <div style={{ marginBottom: '6px' }}>{t('separatusInvestTooltip3')}</div>
            <div>{t('separatusInvestTooltip4')}</div>
          </>
        }
      />
      <SystemCard
        title={t('systemKonvShort')}
        borderColor="#FF9800"
        bgColor="#FFF3E0"
        textColor="#E65100"
        investValue={convertToDisplayCurrency(calculationResult.invest_anteil_konventionelle || 0)}
        yearlyValue={convertToDisplayCurrency(calculationResult.jahreskosten_konventionelle || 0)}
        currency={currency}
        locale={locale}
        tooltipContent={
          <>
            <div style={{ marginBottom: '8px' }}>{t('separatusInvestTooltip1')}</div>
            <div style={{ marginBottom: '6px' }}>{t('separatusInvestTooltip2')}</div>
            <div style={{ marginBottom: '6px' }}>{t('separatusInvestTooltip3')}</div>
            <div>{t('separatusInvestTooltip4')}</div>
          </>
        }
      />
      <div data-pdf-page-break="before">
        <SystemCard
          title={t('systemLuftShort')}
          borderColor="#2196F3"
          bgColor="#E3F2FD"
          textColor="#0D47A1"
          investValue={convertToDisplayCurrency(calculationResult.invest_anteil_luftwaerme || 0)}
          yearlyValue={convertToDisplayCurrency(calculationResult.jahreskosten_luftwaerme || 0)}
          currency={currency}
          locale={locale}
          tooltipContent={
            <>
              <div style={{ marginBottom: '8px' }}>{t('luftInvestTooltip1')}</div>
              <div style={{ marginBottom: '6px' }}>{t('luftInvestTooltip2')}</div>
              <div>{t('luftInvestTooltip3')}</div>
            </>
          }
        />
      </div>
    </div>
  );
};

export default SystemCards;
